import { getCSSCustomProperty } from "@jti/fe-common";

const FLAVOR_THUMBNAIL_SIZE_TOKEN = "--des-dimension-height-and-width-icon-illustration-medium";
// Used on the server, where CSS custom properties cannot be read.
const FLAVOR_THUMBNAIL_SIZE_FALLBACK_PX = 50;

export const getFlavorThumbnailSizePx = (): number =>
  getCSSCustomProperty(FLAVOR_THUMBNAIL_SIZE_TOKEN) ?? FLAVOR_THUMBNAIL_SIZE_FALLBACK_PX;
